import { useState } from 'react';
import { Modal, Button } from '@components/ui';

export default function CompanyModal({ isOpen, onClose, onSubmit }) {
    const [formData, setFormData] = useState({
        name: '',
        shortName: '',
        type: 'supplier',
        phone: '',
        email: '',
        taxNo: '',
        taxOffice: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        specialty: '',
        notes: '',
    });

    const handleSubmit = () => {
        onSubmit?.(formData);
        setFormData({
            name: '', shortName: '', type: 'supplier', phone: '', email: '',
            taxNo: '', taxOffice: '', address: '', contactPerson: '', contactPhone: '',
            specialty: '', notes: '',
        });
        onClose();
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="🏢 Yeni Firma Ekle"
            size="lg"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose}>İptal</Button>
                    <Button variant="primary" onClick={handleSubmit}>Kaydet</Button>
                </>
            }
        >
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Firma Adı *</label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="ABC İnşaat Ltd. Şti."
                            value={formData.name}
                            onChange={(e) => handleChange('name', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Kısa Ad</label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="ABC İnşaat"
                            value={formData.shortName}
                            onChange={(e) => handleChange('shortName', e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Tip *</label>
                        <select
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            value={formData.type}
                            onChange={(e) => handleChange('type', e.target.value)}
                        >
                            <option value="subcontractor">Taşeron</option>
                            <option value="supplier">Tedarikçi</option>
                            <option value="service">Hizmet</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Uzmanlık Alanı</label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="Kaba İnşaat, Betonarme"
                            value={formData.specialty}
                            onChange={(e) => handleChange('specialty', e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Telefon *</label>
                        <input
                            type="tel"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="0212 555 1234"
                            value={formData.phone}
                            onChange={(e) => handleChange('phone', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">E-posta</label>
                        <input
                            type="email"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="info@firma.com"
                            value={formData.email}
                            onChange={(e) => handleChange('email', e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Vergi No</label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="1234567890"
                            value={formData.taxNo}
                            onChange={(e) => handleChange('taxNo', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Vergi Dairesi</label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="Kadıköy Vergi Dairesi"
                            value={formData.taxOffice}
                            onChange={(e) => handleChange('taxOffice', e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">İletişim Kişisi</label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="Ahmet Bey"
                            value={formData.contactPerson}
                            onChange={(e) => handleChange('contactPerson', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">İletişim Telefonu</label>
                        <input
                            type="tel"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="0532 111 2233"
                            value={formData.contactPhone}
                            onChange={(e) => handleChange('contactPhone', e.target.value)}
                        />
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Adres</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                        placeholder="Adres..."
                        value={formData.address}
                        onChange={(e) => handleChange('address', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Not</label>
                    <textarea
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary resize-none"
                        rows={2}
                        placeholder="Notlar..."
                        value={formData.notes}
                        onChange={(e) => handleChange('notes', e.target.value)}
                    />
                </div>
            </div>
        </Modal>
    );
}
